import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState,createContext, useRef } from "react";
import  {getRoleNameByToken } from "../src/Constant/index";
import { API_URL } from "../src/Constant/index";
// import './App.css'
import './styles/custom.css'
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import useAuth from './hooks/useAuth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import messages from './assets/Messages.json';
import {
  Login,
  Dashboard,
  DataUpload,
  Faq,
  Header,
  Footer,
  NavBar,
  ChangePassword,
  CreateNewUser,
  ViewUserList,
  PendencyReport,
  NewPendencyReport,
  UrbanConsumerRetailPriceGraph,
  RularConsumerRetailPriceGraph,
  SixtySevenGraph,
  WholesalePriceGraphReports,
  UrbanConsumerRetailPrice,
  RuralConsumerRetailPrice,
  UrbanCommonSixItemsRetailPrice,
  RuralCommonSixItemsRetailPrice,
  SixtySevenNecessaryItems,
  // WholeSaleKanpur,
  WholeSaleKanpurDistrict,
  PriceForAnimalProduct,
  WholeSaleRawWool,
  WholeSalePriceForAgricultureItemsofHapurMandi,
  PriceAgricultureParityFormforBull,
  PriceAgricultureParityFormMiscellaneous,
  PriceAgricultureParityFormForElectricity,
  WholeSalePrice,
  UrbanWages,
  RuralMenWages,
  RuralWomenWages,
  Block,
  ManufacturingSector,
  MiningSector,
  ElectricitySector,
  AnnualAgriculturalProductionDetails,
  GetASICountPendencyReportNew,
  GetASIPendencyReport,
  GetASICountPendencyReport,
  GetASIPendencyReportDistrict,
  GetASIPendencyReportMandal,
  GetASIPendencyReportHQ,
  GetASIRejectedDSLReport,
  GetListingReportHQ,
  IIPCompilationReport,
  GetPendencyReport,
  BlockAReport,
  IIPAnnualAgricultureReport,
  IIPMiningReport,
  IIPElectricityReport,
  IIPGeneralReport,
  KanpurReport,
  Top5IndexReport,
  Bottom5IndexReport,
  GroupIndexAnnualReport,
  IndexMonthlyComparison,
  AnnualUBCategorisationReport,
  Table1Report,
  Table2Report,
  Table3Report,
  Table4Report,
  Table5Report,
  Table6Report,
  DistrictIndex,
  MultiplierReport,
  Table7Report,
  FRQRReport,
  MajorGroupIndexReport,
  FRQRReportArchive,
  IndexReport,
  ASIBlock,
  ListingReport,
  UrbanCurrentPriceReport,
  UrbanDistrictIndexReport,
  WagesRatesReport,
  PriceElectricityReport,
  BullReport,
  VariationReport,
  PriceAgricultureReport,
  UBReport,
  RuralCentralIndexReport,
  MonthlyPendencyReport,
  DistrictPriceReport,
  UrbanWestIndexReport,
  RuralWestIndexReport,
  UrbanEastIndexReport,
  CentralIndexReport,
  UrbanStateIndexReport,
  UrbanBundelkhandIndexReport,
  RuralEastIndexReport,
  RuralStateIndexReport,
  BundelkhandIndexReport,
  AnimalProductInputReport,
  WholeSaleRawwoolReport,
  MonthlyWholeSalePriceItemwiseReport,
  MonthlyWholeSaleIndexItemwiseReport,
  MajorWPIReport,
  ListReportRuralWages,
  PercentageVariationSheetRuralWageIndex,
  PercentageVariationSheetofUrbanWageindex,
  UrbanRegionalGeneralIndex,
  RuralWageRegionIndex,
  UrbanWageRegionIndex,
  PriceHapurMandiInputReport,
  ListReportUrbanWages,
  WagesIndexReport,
  RCPI,
  AgriculturalParityIndex,
  AnnualAverageOfRuralUrbanWageIndexOfUP,
  CompilationReport,
  Thok1,
  Thok2,
  AnnualIndexPriceReport,
  PercentageVariationReport,
  MonthlyIndicesofallRegionandState,
  RuralConsumerOrnamentsReport,
  WholeSalePriceGroupWiseReport,
  ReviewReport,
  IndexReportWPR,
  RuralRegionalGeneralIndex,
  UrbanPercentageVariation,
  MiscReport,
  WholeSalePriceComparisionReport,
  MonthlyIndicesofallRegionandStateUrban,
  FinalReport,
  AsiDataUpload,
  BalanceSheet,
  AsiScheduleMainMenu,
  BalanceSheetModule,
  FixedAssets,
  BalanceSheetData,
  ProfitAndLossAccount,
  EmploymentAndLabourCost,
  InputItemsIndigenous,
  InputItemsImported,
  ProductsAndByProducts,
  ICTUsageAndEnergyConservation,
  ParticularsOfFieldOperations,
  Validation,
  FixedAssetsData,
  BalanceSheetDataCheck,
  CheckPLAccount,
  CheckPLAccountSorted,
  NetProfitTally,
  ErrorList,
  Reports,
  ReportSelection,
  
  BlockC,
  BlockD,
  BlockE,
  BlockF,
  BlockG,
  BlockH,
  BlockI,
  BlockJ,
  BlockKL,
  BlockMN,
  ScrutinySheet,
  NotFound,
  ASIOtherReport
} from './Components/index';
import RejectedPriceWagesReport from "./Pages/ReportGeneration/PriceWagesIndicesSystem/RejectedPriceWagesReport";
import BlockAAndBReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockAAndBReport";
import BlockCReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockCReport";
import BlockDReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockDReport";
import BlockEReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockEReport";
import BlockAAndB from "./Pages/DataCapture/Asi/BlockAAndB";
import BlockFReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockFReport";
import BlockGReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockGReport";
import BlockHReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockHReport";
import BlockIReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockIReport";
import BlockJReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockJReport";
import BlockKAndLReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockKAndLReport";
import BlockMAndNReport from "./Pages/DataCapture/Asi/balancesheet/report/BlockMAndNReport";
import AllBlocksReport from "./Pages/DataCapture/Asi/balancesheet/report/AllBlocksReport";
import PartII from "./Pages/DataCapture/Asi/balancesheet/report/PartII";
import CentralStoreFigures from "./Pages/DataCapture/Iip/CentralStoreFigures";
import Estimation from "./Pages/DataCapture/Iip/MonthlyProductionDetails/Estimation";


export const MyContextProvider  = createContext();


const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes


// const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes

function App() {
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const [authChecked, setAuthChecked] = useState(false);
  const hasHandledSessionExpiryRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loginInfo, loginCallFromChild, logout } = useAuth();

  const forceLogoutOnSessionExpiry = (messageText = "Session expired or invalid. Please login again.") => {
    if (hasHandledSessionExpiryRef.current) return;
    hasHandledSessionExpiryRef.current = true;
    localStorage.removeItem('jwt');
    localStorage.removeItem('token');
    loginCallFromChild('');
    logout && logout();
    toast.error(messageText, messages.COLOR_RED);
    navigate('/', { replace: true });
  };

  useEffect(() => {
    const token = localStorage.getItem('jwt');
    if (token && token !== 'null' && token.trim() !== '') {
      try {
        const userInfo = jwtDecode(token);
        // Check if token is expired
        const currentTime = Date.now() / 1000;
        if (userInfo.exp && userInfo.exp < currentTime) {
          localStorage.removeItem('jwt');
          logout();
        } else {
          loginCallFromChild(token);
        }
      } catch (error) {
        console.error('Token validation error:', error);
        localStorage.removeItem('jwt');
        logout();
      }
    }
    setAuthChecked(true); // Set this after calling loginCallFromChild
  }, [loginCallFromChild, logout]);

  useEffect(() => {
    const handleActivity = () => setLastActivityTime(Date.now());
    const handleLogout = () => {
      localStorage.removeItem('jwt');
      logout && logout();
      navigate('/');
    };
    // Inactivity timer
    const inactivityCheckInterval = setInterval(() => {
      const timeElapsed = Date.now() - lastActivityTime;
      if (timeElapsed >= INACTIVITY_TIMEOUT) {
        handleLogout();
      }
    }, 1000);
    // Listen for user activity
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('click', handleActivity);
    window.addEventListener('scroll', handleActivity);
    window.addEventListener('touchstart', handleActivity);
    // Remove beforeunload logout to allow refresh/URL navigation
    // window.addEventListener('beforeunload', handleLogout);
    return () => {
      clearInterval(inactivityCheckInterval);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('click', handleActivity);
      window.removeEventListener('scroll', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
      // window.removeEventListener('beforeunload', handleLogout);
    };
  }, [lastActivityTime, navigate, logout]);

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => {
        const message = String(response?.data?.message ?? '').toLowerCase();
        const status = response?.data?.status;
        if (status === false && message.includes('session expired')) {
          forceLogoutOnSessionExpiry(response?.data?.message || "Session expired or invalid. Please login again.");
        }
        return response;
      },
      (error) => {
        const statusCode = error?.response?.status;
        const message = String(error?.response?.data?.message ?? '').toLowerCase();

        if (statusCode === 403 || message.includes('session expired')) {
          forceLogoutOnSessionExpiry(error?.response?.data?.message || "Session expired or invalid. Please login again.");
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, [loginCallFromChild, logout, navigate]);

  // Protect routes: If STATUS_FLAG is "U", redirect to changePwd page
  useEffect(() => {
    if (isAuthenticated && loginInfo && loginInfo.userInfo && loginInfo.userInfo.id) {
      const statusFlag = loginInfo.userInfo.id.STATUS_FLAG;
      const currentPath = location.pathname;
      const storedLanguage = localStorage.getItem('language');
      
      // If STATUS_FLAG is "U" and user is not on changePwd page, redirect to changePwd
      if (statusFlag === 'U' && currentPath !== '/changePwd') {
        const errorMessage = storedLanguage === 'hi'
          ? 'कृपया पहले पासवर्ड अपडेट करें। बिना पासवर्ड अपडेट किए आप दूसरे पेज पर नहीं जा सकते।'
          : 'Please update your password first. You cannot access other pages without updating your password.';
        toast.error(errorMessage, messages.COLOR_RED);
        navigate('/changePwd', { replace: true });
      }
    }
  }, [isAuthenticated, loginInfo, location.pathname, navigate]);

  if (!authChecked) {
    return <div>Loading...</div>; // Or a spinner component
  }


//// without refresh token api....................


  return (
   <>

    { isAuthenticated && loginInfo && loginInfo.userInfo?
      (
      <>
      <Header  UserLevel={loginInfo.userInfo.id.USER_TYPE} LoginUser={loginInfo.userInfo.id.USER_NAME}/>
      <NavBar loginCallToParent={loginCallFromChild} loginInfo={loginInfo.userInfo.id} />
      </>
       )
       :
      ('')
    }
    <MyContextProvider.Provider value={loginInfo ? { ...loginInfo, loginCallFromChild } : { loginCallFromChild }}>
      <Routes>
        { isAuthenticated ?
        (
          
           (loginInfo.userInfo.id.ROLE_CODE==='SUPER' && loginInfo.userInfo.id.USER_TYPE_CODE==='0' ? 

           <>
           <Route path="/addUser" element={<CreateNewUser />} />
           <Route path="/listUsers" element={<ViewUserList />} />
           <Route path="/" element={<Dashboard />} />
           <Route path="/Dashboard" element={<Dashboard />} />
           <Route path="/FrequentlyAskQuestion" element={<Faq />} />
           <Route path="/changePwd" element={<ChangePassword  userId={loginInfo.userInfo.id.USER_ID}/>}/>
           </>
            :
           <>
          <Route path="/DataUpload" element={<DataUpload />} />
          <Route path="/FrequentlyAskQuestion" element={<Faq />} />
          <Route path="/PricePendency" element={<PendencyReport />} />
          <Route path="/PricePendencyAcceptReject" element={<NewPendencyReport />} />
          <Route path="/urban-consumer-retail-price-graph" element={<UrbanConsumerRetailPriceGraph />} />
          <Route path="/rular-consumer-retail-price-graph" element={<RularConsumerRetailPriceGraph />} />
          <Route path="/sixty-seven-graph" element={<SixtySevenGraph />} />
          <Route path="/wholesale-price-graph" element={<WholesalePriceGraphReports />} />
          <Route path="/changePwd" element={<ChangePassword  userId={loginInfo.userInfo.id.USER_ID}/>}/>
          <Route path="/UrbanConsumerPriceInputForm" element={<UrbanConsumerRetailPrice/>}/>
          <Route path="/RuralConsumerPriceInputForm" element={<RuralConsumerRetailPrice/>}/>
          <Route path="/UrbanCommonSixItemPriceForm" element={<UrbanCommonSixItemsRetailPrice/>}/>
          <Route path="/RuralCommonSixItemPriceForm" element={<RuralCommonSixItemsRetailPrice/>}/>
          <Route path="/WholeSalePriceInputForm" element={<WholeSalePrice/>}/> 

          <Route path="/SixtySevenNecessaryItems" element={<SixtySevenNecessaryItems />}/>
          {/* <Route path="/WholeSaleKanpur" element={<WholeSaleKanpur />}/> */}
          <Route path="/WholeSaleKanpurDistrict" element={<WholeSaleKanpurDistrict />}/>
          <Route path="/PriceForAnimalProduct" element={<PriceForAnimalProduct />}/>
          <Route path="/WholeSaleRawWool" element={<WholeSaleRawWool />}/>
          <Route path="/WholeSalePriceForAgriHapurMandi" element={<WholeSalePriceForAgricultureItemsofHapurMandi />}/>
          <Route path="/PriAgricultureProrityFormOne" element={<PriceAgricultureParityFormforBull />}/>
          <Route path="/PriAgricultureProrityFormTwo" element={<PriceAgricultureParityFormMiscellaneous />}/>
          <Route path="/PriAgricultureProrityFormTwo1" element={<PriceAgricultureParityFormForElectricity />}/>
          
          <Route path="/urban_lws" element={<UrbanWages/>}/>
          <Route path="/RuralWagesRatesForMen" element={<RuralMenWages/>}/>
          <Route path="/LwsRuralWageRatesForWomen" element={<RuralWomenWages/>}/>

          {/* iip*/}
          <Route path="/IIPManufacturingSector" element={<ManufacturingSector/>}/>
          <Route path="/IIPMiningSector" element={<MiningSector/>}/>
          <Route path="/IIPElectricitySector" element={<ElectricitySector/>}/>
          <Route path="/IIPEstimationReport" element={<Estimation/>}/>
          <Route path="/AgriculturalProductionDetails" element={<AnnualAgriculturalProductionDetails/>}/>
          <Route path="/CentralStoreFigures" element={<CentralStoreFigures/>}/>


          <Route path="/BlockA" element={<Block/>}/>
          <Route path="/BlockB" element={<Block/>}/>
          <Route path="/BlockC" element={<Block/>}/>
          <Route path="/BlockD" element={<Block/>}/>
          <Route path="/BlockE" element={<Block/>}/>
          <Route path="/BlockF" element={<Block/>}/>
          <Route path="/BlockG" element={<Block/>}/>
          <Route path="/BlockH" element={<Block/>}/>
          <Route path="/BlockI" element={<Block/>}/>
          <Route path="/BlockJ" element={<Block/>}/>
          <Route path="/BlockK" element={<Block/>}/>
          <Route path="/BlockL" element={<Block/>}/>
          <Route path="/BlockM" element={<Block/>}/>
          <Route path="/BlockN" element={<Block/>}/>
          <Route path="/ASIComparision" element={<Block/>}/>
          <Route path="/balanceSheet" element={<BalanceSheetModule/>}/>
          <Route path="/blockAandBreport" element={<BlockAAndBReport/>}/>
          <Route path="/blockCreport" element={<BlockCReport/>}/>
          <Route path="/blockDreport" element={<BlockDReport/>}/>
          <Route path="/blockEreport" element={<BlockEReport/>}/>
          <Route path="/blockFreport" element={<BlockFReport/>}/>
          <Route path="/blockGreport" element={<BlockGReport/>}/>
          <Route path="/blockHreport" element={<BlockHReport/>}/>
          <Route path="/blockIreport" element={<BlockIReport/>}/>
          <Route path="/blockJreport" element={<BlockJReport/>}/>
          <Route path="/blockKAndLreport" element={<BlockKAndLReport/>}/>
          <Route path="/blockMAndNreport" element={<BlockMAndNReport/>}/>
          <Route path="/allblocksreport" element={<AllBlocksReport/>}/>
          <Route path="/blockAandB" element={<BlockAAndB/>}/>
          <Route path="/asiScheduleMainMenu" element={<AsiScheduleMainMenu/>}/>
          <Route path="/fixedAssets" element={<BalanceSheetModule/>}/>
          <Route path="/balanceSheetData" element={<BalanceSheetModule/>}/>
          <Route path="/profitAndLossAccount" element={<BalanceSheetModule/>}/>
          <Route path="/employmentAndLabourCost" element={<BalanceSheetModule/>}/>
          <Route path="/input-items" element={<BalanceSheetModule/>}/>
          <Route path="/input-items-imported" element={<BalanceSheetModule/>}/>
          <Route path="/products-and-by-products" element={<BalanceSheetModule/>}/>
          <Route path="/ict-usage-energy-conservation" element={<BalanceSheetModule/>}/>
          <Route path="/particulars-of-field-operations" element={<BalanceSheetModule/>}/>
          <Route path="/part-a" element={<BalanceSheetModule/>}/>
          <Route path="/part2" element={<BalanceSheetModule/>}/>
          <Route path="/final-checklist" element={<BalanceSheetModule/>}/>
          <Route path="/validation" element={<BalanceSheetModule/>}/>
          <Route path="/report-selection" element={<BalanceSheetModule/>}/>
          <Route path="/fixed-assets-data" element={<FixedAssetsData/>}/>
          <Route path="/balance-sheet-data-check" element={<BalanceSheetDataCheck/>}/>
          <Route path="/check-pl-account" element={<CheckPLAccount/>}/>
          <Route path="/check-pl-account-sorted" element={<CheckPLAccountSorted/>}/>
          <Route path="/net-profit-tally" element={<NetProfitTally/>}/>
          <Route path="/error-list" element={<ErrorList/>}/>
          {/* <Route path="/reports" element={<Reports/>}/> */}
          <Route path="/report-selection" element={<ReportSelection/>}/>
          {/* <Route path="/block-a-and-b" element={<BlockAAndB/>}/> */}
          <Route path="/block-c" element={<BlockC/>}/>
          <Route path="/block-d" element={<BlockD/>}/>
          <Route path="/block-e" element={<BlockE/>}/>
          <Route path="/block-f" element={<BlockF/>}/>
          <Route path="/block-g" element={<BlockG/>}/>
          <Route path="/block-h" element={<BlockH/>}/>
          <Route path="/block-i" element={<BlockI/>}/>
          <Route path="/block-j" element={<BlockJ/>}/>
          <Route path="/block-kl" element={<BlockKL/>}/>
          <Route path="/block-mn" element={<BlockMN/>}/>
          <Route path="/partIIreport" element={<PartII/>}/>
          <Route path="/scrutiny-sheet" element={<ScrutinySheet/>}/>
          <Route path="/" element={<Dashboard />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/GetListingReportHQ" element={<GetListingReportHQ />} />
          <Route path="/GetPendencyReport" element={<GetPendencyReport />} />
          <Route path="/IIPNICBasedReport" element={<IIPCompilationReport />} />
          <Route path="/GetASICountPendencyReportNew" element={<GetASICountPendencyReportNew />} />
          <Route path="/GetASIPendencyReport" element={<GetASIPendencyReport />} />
          <Route path="/GetASICountPendencyReport" element={<GetASICountPendencyReport />} />
          <Route path="/GetASIPendencyReportDistrict" element={<GetASIPendencyReportDistrict />} />
          <Route path="/GetASIPendencyReportMandal" element={<GetASIPendencyReportMandal />} />
          <Route path="/GetASIPendencyReportHQ" element={<GetASIPendencyReportHQ />} />
          <Route path="/GetASIRejectedDSLReport" element={<GetASIRejectedDSLReport />} />
          <Route path="/BlockAReport" element={<BlockAReport />} />
          <Route path="/IIPAnnualAgricultureReport" element={<IIPAnnualAgricultureReport />} />
          <Route path="/IIPMiningReport" element={<IIPMiningReport />} />
          <Route path="/IIPElectricityReport" element={<IIPElectricityReport />}/>
          <Route path="/IIPGeneralReport" element={<IIPGeneralReport />}/>
          <Route path="/kanpurreport" element={<KanpurReport />}/>
          <Route path="/IIPTop5Index" element={<Top5IndexReport />}/>
          <Route path="/IIPBottom5Index" element={<Bottom5IndexReport />}/>
          <Route path="/IIPFRQRReport" element={<FRQRReport />}/>
          <Route path="/IIPFRQRReportArchive" element={<FRQRReportArchive />}/>
          <Route path="/GetGroupIndexAnnualReport" element={<GroupIndexAnnualReport />}/>
          <Route path="/IIPIndexMonthlyComparison" element={<IndexMonthlyComparison />}/>
          <Route path="/IIPAnnualUB" element={<AnnualUBCategorisationReport />}/>
          <Route path="/ASITable1" element={<Table1Report />}/>
          <Route path="/ASITable2" element={<Table2Report />}/>
          <Route path="/ASITable3" element={<Table3Report />}/>
          <Route path="/ASITable4" element={<Table4Report />}/>
          <Route path="/ASITable5" element={<Table5Report />}/>
          <Route path="/ASITable6" element={<Table6Report />}/>
          <Route path="/ASITable7" element={<Table7Report />}/>
          <Route path="/RCDistrictIndex" element={<DistrictIndex />}/>
          <Route path="/Multiplier" element={<MultiplierReport />}/>
          <Route path="/DownloadASIBlockData" element={<ASIBlock />}/>
          <Route path="/getASIListingReport" element={<ListingReport />}/>
          <Route path="/IIPMajorGroupIndexReport" element={<MajorGroupIndexReport />}/>
          <Route path="/IIPIndexReport" element={<IndexReport/>}/>
          <Route path="/IIPManufacturingMonthWisePendency" element={<MonthlyPendencyReport/>}/>
          {/* <Route path="/ASIOtherReport" element={<ASIOtherReport/>}/> */}
          
          {/************* Price Wages Indices System / Urban Consumer Retail Price  ***********/}
          <Route path="/UrbanCurrentPriceReport" element={<UrbanCurrentPriceReport/>}/>
          <Route path="/UrbanDistrictIndexReport" element={<UrbanDistrictIndexReport/>}/>
          <Route path="/UrbanWestIndexReport" element={<UrbanWestIndexReport/>}/>
          <Route path="/priwagesratesreport" element={<WagesRatesReport/>}/>
          <Route path="/PriElectricityReport" element={<PriceElectricityReport />}/>
          <Route path="/privariationreport" element={<VariationReport/>}/>
          <Route path="/PriBullReport" element={<BullReport />}/>
          <Route path="/PriAgricultureReport" element={<PriceAgricultureReport/>}/>
          <Route path="/IIPUBReport" element={<UBReport/>}/>

          <Route path="/RuralCentralIndexReport" element={<RuralCentralIndexReport />}/>
          <Route path="/RuralDistrictPriceReport" element={<DistrictPriceReport />}/>
          <Route path="/RuralWestIndexReport" element={<RuralWestIndexReport/>}/>
          <Route path="/UrbanEastIndexReport" element={<UrbanEastIndexReport/>}/>
          <Route path="/UrbanCentralIndexReport" element={<CentralIndexReport/>}/>
          <Route path="/UrbanStateIndexReport" element={<UrbanStateIndexReport/>}/>
          <Route path="/UrbanBundelkhandIndexReport" element={<UrbanBundelkhandIndexReport/>}/>
          <Route path="/RuralEastIndexReport" element={<RuralEastIndexReport/>}/>
          <Route path="/RuralStateIndexReport" element={<RuralStateIndexReport/>}/>
          <Route path="/RuralBundelkhandIndexReport" element={<BundelkhandIndexReport />}/>
          <Route path="/PriAnimalReport" element={<AnimalProductInputReport />}/>
          <Route path="/Priwholesalerawwool" element={<WholeSaleRawwoolReport />}/>
          <Route path="/MonthlyWholeSalePriceItemwiseReport" element={<MonthlyWholeSalePriceItemwiseReport />}/>
          <Route path="/MonthlyWholeSaleIndexItemwiseReport" element={<MonthlyWholeSaleIndexItemwiseReport />}/>
         <Route path="/MajorWPI" element={<MajorWPIReport />}/>
     
          <Route path="/PriListReportRuralWages" element={<ListReportRuralWages />}/>
          <Route path="/PriPercentageVartiationSheetRuralWageIndexReport" element={<PercentageVariationSheetRuralWageIndex />}/>
          <Route path="/PercentageVariationSheetofUrbanWageIndexReport" element={<PercentageVariationSheetofUrbanWageindex />}/>
          <Route path="/UrbanRegionalGeneralIndex" element={<UrbanRegionalGeneralIndex />}/>
          <Route path="/PriRuralWageRegionIndex" element={<RuralWageRegionIndex />}/>
          <Route path="/PriceLwsUrbanRegionReport" element={<UrbanWageRegionIndex />}/>
          <Route path="/PriHapurMandiReport" element={<PriceHapurMandiInputReport />}/>
          <Route path="/ListReportUrbanWages" element={<ListReportUrbanWages />}/>
          <Route path="/PriWagesIndexReport" element={<WagesIndexReport />}/>
          <Route path="/PriRCPI" element={<RCPI />}/>
          <Route path="/Pri_Agricultural_Parity_Index" element={<AgriculturalParityIndex />}/>
          <Route path="/priceLwsAnnualAverageRuralUrbanIndexUP" element={<AnnualAverageOfRuralUrbanWageIndexOfUP />}/>
          <Route path="/Pri67CompilationReport" element={<CompilationReport />}/>
          <Route path="/PriThok1" element={<Thok1 />}/>
          <Route path="/PriThok2" element={<Thok2 />}/>
          <Route path="/PriWPAnnualIndexpriceReport" element={<AnnualIndexPriceReport />}/>
          <Route path="/PercentageVariationReport" element={<PercentageVariationReport />}/>
          <Route path="/MonthlyIndicesofallRegionandState" element={<MonthlyIndicesofallRegionandState />}/>
          <Route path="/RuralConsumerOrnamentsReport" element={<RuralConsumerOrnamentsReport />}/>
          <Route path="/WholeSalePriceGroupWiseReport" element={<WholeSalePriceGroupWiseReport />}/>
          <Route path="/PriReviewReport" element={<ReviewReport />}/>
          <Route path="/PriIndexReport" element={<IndexReportWPR />}/>
          <Route path="/RuralRegionalGeneralIndex" element={<RuralRegionalGeneralIndex />}/>
          <Route path="/UrbanPercentageVariationReport" element={<UrbanPercentageVariation />}/>
          <Route path="/PriAgricultureParityMiscReport" element={<MiscReport />}/>
          <Route path="/PriWholeSalePriceComparisionReport" element={<WholeSalePriceComparisionReport />}/>
          <Route path="/MonthlyIndicesofallRegionandStateUrban" element={<MonthlyIndicesofallRegionandStateUrban />}/>
          <Route path="/PriFinalReport" element={<FinalReport />}/>
          <Route path="/RejectedPriceWagesReport" element={<RejectedPriceWagesReport />}/>
          <Route path="/UploadPage" element={<AsiDataUpload />}/>


          </>
          )
          
          

        )
        :
        (
        <>
        <Route path="/" element={<Login loginCallToParent={loginCallFromChild}/>} />
        
        </>
        )
      }
         <Route path="*"  element={<NotFound />} />  
       </Routes>
       </MyContextProvider.Provider>
       <ToastContainer />
       { isAuthenticated ? (<><Footer/></>): '' }
    
   </>
  );
}

export default App;
